import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExpandingTextField',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const fieldRef = ref(null);
        let observer;
        let fittedWidth = 0;
        function textarea() {
            return fieldRef.value?.$el?.querySelector?.("textarea") ?? null;
        }
        // Sized here, not by Vuetify's auto-grow: that reads its own padding variables, not the house padding,
        // so it comes up a row short and the last row ends up clipped.
        function fit() {
            const el = textarea();
            if (!el)
                return;
            el.style.height = "auto";
            const height = el.scrollHeight;
            fittedWidth = el.getBoundingClientRect().width;
            el.style.height = `${height}px`;
        }
        // Refit when the width changes: a field in a closed panel has no width to wrap against until it opens.
        // Our own height change is ignored, and the refit waits a frame so the observer is not re-entered.
        onMounted(() => {
            const el = textarea();
            fit();
            if (el && typeof ResizeObserver !== "undefined") {
                observer = new ResizeObserver(() => {
                    if (el.getBoundingClientRect().width !== fittedWidth)
                        requestAnimationFrame(fit);
                });
                observer.observe(el);
            }
            if (document.fonts && document.fonts.status !== "loaded")
                document.fonts.ready.then(fit);
        });
        onBeforeUnmount(() => observer?.disconnect());
        watch(() => props.modelValue, () => nextTick(fit));
        // The answer stays one paragraph, as it was in a text field: a pasted line break becomes a space.
        function onUpdate(value) {
            emit("update:modelValue", (value ?? "").replace(/\r?\n/g, " "));
        }
        return (_ctx, _cache) => {
            const _component_v_textarea = _resolveComponent("v-textarea");
            return (_openBlock(), _createBlock(_component_v_textarea, {
                ref_key: "fieldRef",
                ref: fieldRef,
                class: "expanding-text-field",
                "model-value": __props.modelValue,
                rows: 1,
                "no-resize": "",
                "onUpdate:modelValue": onUpdate,
                onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"]))
            }, null, 8, ["model-value"]));
        };
    }
});
